import { createCsrfMiddleware, createStart } from '@tanstack/react-start';
import { isSiteOrigin, trustedOrigins } from '~/lib/server-fn-origin';

/*
 * Defining a Start instance replaces Start's default server-function CSRF
 * middleware, so this re-installs it with the same rules: `Sec-Fetch-Site` must
 * be `same-origin` when present, otherwise `Origin` (or the `Referer` origin)
 * must be this site, and a request carrying none of the three is rejected. The
 * only change is that "this site" also means the public origins, not just the
 * internal URL the server sees behind the load balancer (see `isSiteOrigin`).
 */
const serverFnCsrfMiddleware = createCsrfMiddleware({
  filter: (ctx) => ctx.handlerType === 'serverFn',
  // Runs on the server only. SERVER_URL is required in production
  // (src/plugins/validate-production-env.ts), the same value server-env.ts uses.
  origin: (origin, ctx) =>
    isSiteOrigin(
      origin,
      ctx.request.url,
      trustedOrigins(process.env.SERVER_URL, process.env.ADDITIONAL_TRUSTED_ORIGINS),
    ),
});

export const startInstance = createStart(() => ({
  requestMiddleware: [serverFnCsrfMiddleware],
}));
